<svg:g
  class="top-wrapper"
  [class.selected]="subpointInfo.selected"
  attr.transform="translate({{ subpointInfo.point.join(',') }})"
  [style.display]="subpointInfo.hidden ? 'none' : undefined"
>
  <g class="scaling-group">
    <ng-container *ngIf="subpointInfo.renderAsDiamond">
      <polygon class="outer-shape" points="0,1.6 1,0 0,-1.6 -1,0" />
      <polygon class="middle-shape" points="0,1.16 .727,0 0,-1.16 -.727,0" />
      <polygon class="inner-shape" points="0,.727 .454,0 0,-.727 -.454,0" />
    </ng-container>

    <ng-container *ngIf="!subpointInfo.renderAsDiamond">
      <circle class="outer-shape" r="1" />
      <circle class="middle-shape" r="0.727" />
      <circle class="inner-shape" r="0.454" />
    </ng-container>
  </g>
</svg:g>
